import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

import loadingLottie from '../../assets/lottie/loadingSecondary.json';

import classes from './lottieLoader.module.css';

const LottieLoader = ({ className }) => {
  return (
    <div className={`${classes?.container} ${className && className}`}>
      <Player
        autoplay
        loop
        src={loadingLottie}
        style={{ height: '300px', width: '300px' }}></Player>
    </div>
  );
};

export default LottieLoader;
